import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { fetchCategory, fetchSpecifications } from 'SRC/modules/categories/actions'
import { Page } from 'SRC/ui'
import { Header } from '../Header'
import { Content } from '../Content'
import { getCurrentAd } from '../../selectors'

export const DetailPage = ({
  ad,
  fetchCategory,
  fetchSpecifications
}) => {
  React.useEffect(() => {
    if (ad && ad.category && fetchCategory && fetchSpecifications) {
      fetchCategory({ seo: ad.category.seo, layoutStyle: 'no-sidebar' }, false)
      fetchSpecifications(ad.category.id)
    }
  }, [])

  if (ad) {
    return (
      <Page>
        <Header />
        <Content />
      </Page>
    )
  }

  return <Page />
}

DetailPage.propTypes = {
  ad: PropTypes.shape(),
  fetchCategory: PropTypes.func.isRequired,
  fetchSpecifications: PropTypes.func.isRequired
}

const mapStateToProps = state => {
  return {
    ad: getCurrentAd(state)
  }
}

export default connect(mapStateToProps, { fetchCategory, fetchSpecifications })(DetailPage)
